import { defineComponent as t, computed as p } from "vue";
const o = /* @__PURE__ */ t({
  __name: "input-wrapper",
  props: {
    label: { default: void 0 },
    labelClass: { default: void 0 },
    id: { default: void 0 },
    errorMessage: { default: void 0 },
    hintMessage: { default: void 0 },
    inlineLabel: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    readonly: { type: Boolean, default: !1 },
    showLabel: { type: Boolean, default: !1 },
    medium: { type: Boolean, default: !1 },
    large: { type: Boolean, default: !1 },
    hasFixedValue: { type: Boolean, default: !1 },
    value: { default: void 0 }
  },
  setup(s, { expose: i }) {
    const e = s, l = p(() => !!e.errorMessage), r = p(
      () => e.value !== void 0 && e.value !== null && e.value !== ""
    ), u = p(() => {
      const a = [];
      return l.value && a.push("input-wrapper--error"), e.disabled && a.push("input-wrapper--disabled"), e.readonly && a.push("input-wrapper--readonly"), e.medium ? a.push("input-wrapper--inline-label input-wrapper--medium") : e.large ? a.push("input-wrapper--inline-label input-wrapper--large") : e.inlineLabel && a.push("input-wrapper--inline-label"), (r.value || e.hasFixedValue) && a.push("input-wrapper--has-value"), a;
    });
    return i({ wrapperClass: u, hasError: l }), { __sfc: !0, props: e, hasError: l, hasValue: r, wrapperClass: u };
  }
});
export {
  o as default
};
